import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ChangePasswordAPI, forgetPasswordAPI, loginAPI, signupAPI } from "../../api/auth/AuthApi";
import { getTokenPayload, saveToken } from "../../../token/token";
import { openEdgeSession } from "../../../util/openEdgeSession";

const getInitialHasCompanyVerified = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const storedValue = window.sessionStorage.getItem("hasCompanyVerified");

  if (storedValue === null) {
    return null;
  }

  return storedValue === "true";
};

const toVerificationState = (value) => {
  if (value === null || typeof value === "undefined") {
    return null;
  }

  return value === true || value === "true";
};

const initialState = {
  login: null,
  loading: null,
  error: {},
  reseting: false,
  hasCompanyVerified: getInitialHasCompanyVerified(),
};

export const singup = createAsyncThunk(
  "auth/singup",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await signupAPI(payload);
      window.location = "/";
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message || err?.data?.message,
      });
    }
  }
);

export const login = createAsyncThunk(
  "auth/login",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await loginAPI(payload);
      if (response.data.success) {
        const { accessToken } = response?.data?.response || {};
        saveToken(accessToken);
        const tokenPayload = getTokenPayload("token");
        await openEdgeSession(
          process.env.REACT_APP_CLOUDFRONT_DOMAIN,
          accessToken
        );
        window.sessionStorage.removeItem("hasCompanyVerified");
        const isSellerLikeRole = ["SELLER", "STAFF"].includes(
          tokenPayload?.role
        );
        window.location =
          isSellerLikeRole && Boolean(tokenPayload?.isNewUser)
            ? "/admin/home"
            : isSellerLikeRole && Boolean(!tokenPayload?.isNewUser) ? "admin/magic" : "admin/magic";

        return response;
      } else {
        throw new Error(response.data.message);
      }
    } catch (err) {
      console.log("err", err)
      return rejectWithValue({
        errorMessage: err?.message || err?.data?.message,
      });
    }
  }
);

export const forgetPassword = createAsyncThunk(
  "auth/forgetPassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await forgetPasswordAPI(payload);
      return response;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const updateChangePassword = createAsyncThunk(
  "auth/updateChangePassword",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ChangePasswordAPI(payload);
      if (response.status === 200) {
        window.location = "/login";
      }
      if (response.response.data.status === 500) {
        return response.response.data;
      }
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setHasCompanyVerified: (state, action) => {
      const hasCompanyVerified = toVerificationState(action.payload);
      state.hasCompanyVerified = hasCompanyVerified;

      if (typeof window !== "undefined") {
        if (hasCompanyVerified === null) {
          window.sessionStorage.removeItem("hasCompanyVerified");
        } else {
          window.sessionStorage.setItem(
            "hasCompanyVerified",
            String(hasCompanyVerified)
          );
        }
      }
    }
  },
  extraReducers: (builder) => {
    //login user
    builder.addCase(login.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.login = action.payload.data.response.accessToken;
      saveToken(action.payload.data.response.accessToken);
      state.loading = false;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //login user
    builder.addCase(forgetPassword.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(forgetPassword.fulfilled, (state, action) => {
      // state.login = action.payload.data.response.accessToken;
      state.loading = false;
    });
    builder.addCase(forgetPassword.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //update password
    builder.addCase(updateChangePassword.pending, (state) => {
      state.reseting = true;
    });
    builder.addCase(updateChangePassword.fulfilled, (state, action) => {
      state.reseting = false;
    });
    builder.addCase(updateChangePassword.rejected, (state) => {
      state.reseting = false;
    });

    //signup user
    builder.addCase(singup.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(singup.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(singup.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default authSlice.reducer;
export const { setHasCompanyVerified } = authSlice.actions;
